/*==================================================
セレクトボックス トグルメニュー
==================================================*/
if($('.jsFormSelectContent').length) {
  if (!navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
    $('.jsFormSelectContent').hide();
    $('.jsFormSelect').on('click', function (e) {
      $(this).find('.select-result').toggleClass('open');
      $(this).find('.jsFormSelectContent').stop().slideToggle(200);
      $('.jsFormSelect').not($(this)).find('.jsFormSelectContent').stop().slideUp(200);
      $('.jsFormSelect').not($(this)).find('.select-result').removeClass('open');
      e.stopPropagation();
    });
    $('.jsFormSelectContent').on('click', function (e) {
      $(this).stop().slideDown(0);
      e.stopPropagation();
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.jsFormSelect').length) {
        $('.jsFormSelect').find('.jsFormSelectContent').stop().slideUp(200);
        $('.select-result').removeClass('open');
      }
    });
  } else {
    $(function () {
      $('.jsFormSelectContent').hide();
      $('.jsFormSelect').on('click', function (e) {
        $(this).find('.select-result').toggleClass('open');
        $(this).find('.jsFormSelectContent').stop().slideToggle(200);
        $('.jsFormSelect').not($(this)).find('.jsFormSelectContent').stop().slideUp(200);
        $('.jsFormSelect').not($(this)).find('.select-result').removeClass('open');
        e.stopPropagation();
      });
      $('.jsFormSelectContent').on('click', function (e) {
        $(this).stop().slideDown(0);
        e.stopPropagation();
      });
      $(document).on('click', function (e) {
        if (!$(e.target).closest('.jsFormSelect').length) {
          $('.jsFormSelect').find('.jsFormSelectContent').stop().slideUp(200);
          $('.select-result').removeClass('open');
        }
      });
    });
  };
}
/*==================================================
//tableのチェックボックス クラス操作
==================================================*/
if($('.td-left').length) {
  $(function() {
    $('.field-checkbox-input').change(function(){
      if( $(this).prop('checked') ){
        $(this).parent().parent().parent('.td-left').addClass('select');
      }else{
        $(this).parent().parent().parent('.td-left').removeClass('select');
      }
    });
  });
};

/*==================================================
//セレクトボックスを選択したら選択したものを表示
==================================================*/
$(function () {
  if($('.jsFormSelectContent').length) {
    /*
    ▼親checkboxがcheckedになったら子checkboxもcheckedに変化(都道府県)
    */
    $('.field-heading').on('click', function() {
      if($(this).find('.field-checkbox-input').prop('checked')) {
        $(this).parent('.field-list').children('.field-checkbox').find('.field-checkbox-input').prop('checked', true);
      }else{
        $(this).parent('.field-list').children('.field-checkbox').find('.field-checkbox-input').prop('checked', false);
      };
    });
    /*
    ▲親checkboxがcheckedになったら子checkboxもcheckedに変化(都道府県)
    */

    /*
    ▼checkedの子checkboxがない時にグループの親checkboxのcheckedを解除 (都道府県)
    */
    $('.field-list').on('click', function () {
      if($(this).find('.field-checkbox').find('input:checked').length == 0) {
        $(this).find('.field-heading').find('.field-checkbox-input').prop('checked', false);
      }
    });
    /*
    ▲checkedの子checkboxがない時にグループの親checkboxのcheckedを解除 (都道府県)
    */

    $('.field-box').on('click', function () {
        /*
        ▼「指定しない」と選択したワードを入れ替える
        */
        let result = $(this).parent('.form-content').children('.select-result');
        // 選択結果のタグの親タグ
        let text = result.html();
        // 選択結果のタグの親タグ内のタグを取得
        let regExp = new RegExp('<span class="no-select">指定しない</span>', "g");
        // textから「指定しない」を絞りこむ
        let selected = text.replace(regExp, "");
        // 選択結果のタグの親タグ内から「指定しない」を削除
        $(this).parent('.form-content').children('.select-result').html(selected);
        // 「指定しない」を取り除いたタグ内容を元あった場所に戻す
        let words = '';
        $(this).find('.field-checkbox').find('.field-checkbox-input:checked').next('.checkbox-parts').each(function(){
          words+="<span>" + $(this).text() + "</span>";
        });
        $(this).parent('.form-content').children('.select-result').children('.selected').html(words);
        /*
        ▲「指定しない」と選択したワードを入れ替える
        */

        /*
        ▼選択が1つもない時、「指定しない」を戻す。
        */
        if ($(this).find('.field-checkbox').find('.field-checkbox-input').prop("checked") == false) {
          let selectedTag = $(this).parent('.form-content').children('.select-result').children('.selected');
          let result = $(this).parent('.form-content').children('.select-result');
          if (selectedTag.find('span').length == 0) {
            result.append('<span class="no-select">指定しない</span>');
          };
        };
        /*
        ▲選択が1つもない時、「指定しない」を戻す。
        */


      /*
      ▼指定したものに重複があったら削除
      */
      const set = new Set();

      $('.select-result').children('.selected').children('span').filter(
          function() {
              const t = $(this).text();
              if (set.has(t))
                  return true;
              else {
                  set.add(t);
                  return false;
              }
          }
      ).remove();
    });
    /*
    ▲指定したものに重複があったら削除
    */
  };
});
